import request from "@/utils/request";

export interface PageQuery {
  current?: number;
  size?: number;
}

export interface QuestionGroupForm {
  id?: number | null;
  questionId: number | null;
  groupCode: string;
  groupName: string;
  groupType?: string;
  description?: string;
  scoreMethod?: string;
  sort: number;
}

export interface QuestionGroupItemForm {
  id?: number | null;
  groupId: number | null;
  itemId: number | null;
  itemWeight?: number;
  sort: number;
}

export interface QuestionResultForm {
  id?: number | null;
  questionId: number | null;
  groupId?: number | null;
  resultCode: string;
  resultName: string;
  resultDesc?: string;
  suggestion?: string;
  minScore?: number | null;
  maxScore?: number | null;
  sort: number;
}

export interface QuestionGroupDetailForm {
  group: QuestionGroupForm;
  itemIds: number[];
  results: QuestionResultForm[];
}

export interface QuestionRuleForm {
  id?: number | null;
  questionId: number | null;
  sourceType?: string;
  sourceField?: string;
  itemId: number | null;
  optionId?: number | null;
  conditions: string;
  compareValue?: string;
  targetItemId: number | null;
  action: string;
  description?: string;
  status: number;
  sort: number;
}

export function getQuestionGroupList(data: PageQuery & Partial<QuestionGroupForm>): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionGroup/list",
    type: "params",
    data
  });
}

export function addQuestionGroup(data: QuestionGroupForm): Promise<any> {
  return request({
    method: "PUT",
    url: "manage/questionGroup/add",
    data
  });
}

export function updateQuestionGroup(data: QuestionGroupForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionGroup/update",
    data
  });
}

export function saveQuestionGroupDetail(data: QuestionGroupDetailForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionGroup/saveDetail",
    data
  });
}

export function deleteQuestionGroup(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/questionGroup/delete",
    type: "params",
    data: { id }
  });
}

export function getQuestionGroupItemList(data: PageQuery & Partial<QuestionGroupItemForm>): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionGroupItem/list",
    type: "params",
    data
  });
}

export function addQuestionGroupItem(data: QuestionGroupItemForm): Promise<any> {
  return request({
    method: "PUT",
    url: "manage/questionGroupItem/add",
    data
  });
}

export function updateQuestionGroupItem(data: QuestionGroupItemForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionGroupItem/update",
    data
  });
}

export function deleteQuestionGroupItem(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/questionGroupItem/delete",
    type: "params",
    data: { id }
  });
}

export function getQuestionResultList(data: PageQuery & Partial<QuestionResultForm>): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionResult/list",
    type: "params",
    data
  });
}

export function addQuestionResult(data: QuestionResultForm): Promise<any> {
  return request({
    method: "PUT",
    url: "manage/questionResult/add",
    data
  });
}

export function updateQuestionResult(data: QuestionResultForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionResult/update",
    data
  });
}

export function deleteQuestionResult(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/questionResult/delete",
    type: "params",
    data: { id }
  });
}

export function getQuestionRuleList(data: PageQuery & Partial<QuestionRuleForm>): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRule/list",
    type: "params",
    data
  });
}

export function addQuestionRule(data: QuestionRuleForm): Promise<any> {
  return request({
    method: "PUT",
    url: "manage/questionRule/add",
    data
  });
}

export function updateQuestionRule(data: QuestionRuleForm): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionRule/update",
    data
  });
}

export function copyQuestionRule(id: number): Promise<any> {
  return request({
    method: "POST",
    url: "manage/questionRule/copy",
    type: "params",
    data: { id }
  });
}

export function deleteQuestionRule(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/questionRule/delete",
    type: "params",
    data: { id }
  });
}
